import React from 'react';
export var AnimationsSettingsContext = /*#__PURE__*/React.createContext({
  enabled: true,
  pageTransition: {}
});
export var AnimationsSettingsProvider = AnimationsSettingsContext.Provider;